export { default as CmsLinkCarousel, getSlides } from './CmsLinkCarousel';
